import React from 'react';
import { Link } from 'react-router-dom';
import { User, Baby, Users, Heart, Shield, Building, ArrowRight } from 'lucide-react';

const services = [
  {
    id: 1,
    icon: User,
    serviceValue: 'individual',
    title: 'Индивидуальная терапия',
    description: 'Работа с личными проблемами, тревогой, депрессией, самооценкой и жизненными кризисами.'
  },
  {
    id: 2,
    icon: Baby,
    serviceValue: 'child',
    title: 'Детская психология',
    description: 'Помощь детям в адаптации, преодолении страхов, проблем в обучении, поведении и социализации.'
  },
  {
    id: 3,
    icon: Users,
    serviceValue: 'family',
    title: 'Семейная терапия',
    description: 'Восстановление отношений в семье, работа с конфликтами, помощь в кризисных ситуациях.'
  },
  {
    id: 4,
    icon: Heart,
    serviceValue: 'crisis',
    title: 'Кризисная помощь',
    description: 'Экстренная психологическая поддержка в острых жизненных ситуациях и травматических событиях.'
  },
  {
    id: 5,
    icon: Shield,
    serviceValue: 'suicide',
    title: 'Суицидальный кризис',
    description: 'Профессиональная помощь в ситуациях суицидального риска. Конфиденциально и безопасно.'
  },
  {
    id: 6,
    icon: Building,
    serviceValue: 'corporate',
    title: 'Корпоративная психология',
    description: 'Психологическое сопровождение компаний, тренинги, работа с выгоранием сотрудников.'
  }
];

const ServicesSection = () => {
  return (
    <section id="services" className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-6">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-16">
          <p className="text-teal-600 font-medium tracking-[0.3em] uppercase text-xs mb-3">
            Услуги
          </p>
          <h2 className="text-3xl md:text-4xl font-serif text-stone-800 mb-4">
            Направления работы
          </h2>
          <p className="text-stone-600 text-lg">
            Профессиональная психологическая помощь для детей, взрослых и семей.<br />
            Индивидуальный подход к каждому клиенту.
          </p>
        </div>

        {/* Services Grid - 3 columns */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service) => {
            const IconComponent = service.icon;
            
            return (
              <div
                key={service.id}
                className="group bg-white border border-sand-200 hover:border-teal-200 hover:shadow-xl rounded-2xl p-8 transition-all duration-300"
              >
                {/* Icon */}
                <div className="w-14 h-14 bg-sand-100 group-hover:bg-teal-600 rounded-xl flex items-center justify-center mb-5 transition-colors duration-300">
                  <IconComponent 
                    size={28} 
                    className="text-teal-600 group-hover:text-white transition-colors duration-300" 
                  />
                </div>

                {/* Content */}
                <h3 className="text-xl font-semibold text-stone-800 mb-3">
                  {service.title}
                </h3>
                <p className="text-stone-600 leading-relaxed mb-5">
                  {service.description}
                </p>

                {/* Link */}
                <Link
                  to={`/services?service=${encodeURIComponent(service.serviceValue)}`}
                  className="inline-flex items-center text-teal-600 font-medium text-sm group-hover:gap-2 transition-all"
                >
                  Подробнее
                  <ArrowRight size={16} className="ml-1 group-hover:translate-x-1 transition-transform" />
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
